<!-- @format -->

<member-add-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h2 class="heading-01 heading_invite">メンバーの招待</h2>

        <p class="modal_lead">
          EDITECH
          HUBのグループにメンバー追加をするための招待メールを送信します。
          <br />
          招待したいユーザーのメールアドレスと付与する権限を設定してください。
        </p>

        <form class="" name="form01" action="">
          <div class="wrap_input wrap_input-60">
            <label class="form-heading" for="mail01">メールアドレス</label>
            <input
              class="text_input"
              type="text"
              name="mail"
              id="mail"
              is="binding"
              data="{ state }"
              placeholder="user-address@cro-co.co.jp"
            />
          </div>
          <!--/.wrap_input-->
          <div class="wrap_input wrap_input-60">
            <label class="form-heading" for="mail02">
              メールアドレス（確認用）
            </label>
            <input
              class="text_input"
              type="text"
              name="mail2"
              id="mail2"
              is="binding"
              data="{ state }"
              placeholder="user-address@cro-co.co.jp"
            />
          </div>
          <!--/.wrap_input-->
          <div class="wrap_input wrap_input-30">
            <label class="form-heading" for="role">権限</label>
            <select
              name="role"
              id="role"
              class="sort-list"
              onchange="{ onRole }"
            >
              <option each="{ role in Role.roles() }" value="{ role.id }">
                {role.name}
              </option>
            </select>
            <p class="notice">
              ※権限の詳細に関しては
              <a href="/menu/about-role">こちら</a>
            </p>
          </div>
          <!--/.wrap_input-->
        </form>
        <p class="notice">
          ※招待メールは72時間有効です。有効時間が過ぎると招待メールは無効になります。
        </p>
        <p class="notice">
          ※招待の取り消しはできません（追加完了後の削除を管理者、マネージャー権限で行うことは可能です）。
        </p>

        <div class="container_button">
          <button
            class="button button-clear js-modal-close"
            type="button"
            onclick="{ props.onClose }"
          >
            キャンセル
          </button>
          <button
            class="button button-primary button-primary-mini"
            type="button"
            onclick="{ invite }"
          >
            招待メール送信
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import di from "dependeny-injection";
    import Role from "@model/role.js";
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      state: {
        errorMessage: false,
        mail: "",
        mail2: "",
        role: "",
      },
      onBeforeMount() {
        this.Role = Role;
      },
      onBeforeShow() {
        this.update({
          mail: "",
          mail2: "",
          role: "master",
        });
      },
      onRole(e) {
        this.update({ role: e.target.value });
      },
      delError(e) {
        this.update({ errorMessage: false });
      },
      async invite(e) {
        if (!this.state.mail) {
          this.update({ errorMessage: "メールアドレスを入力して下さい" });
          di.toast.push(this.state.errorMessage, "negative");
          return false;
        }
        if (this.state.mail != this.state.mail2) {
          this.update({
            errorMessage: "メールアドレス（確認用）が一致しません",
          });
          di.toast.push(this.state.errorMessage, "negative");
          return false;
        }
        if (!confirm(`本当に${this.state.mail}を招待しますか？`)) {
          return false;
        }
        this.update({ isLoading: true });
        this.props.onAdd(e, this.state.mail, this.state.role);
      },
    };
  </script>
</member-add-modal>
